import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
//import { Helpers } from '../helpers/helpers';
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "./../models/user.model";
import { Subscription } from "rxjs";
import { ZpDataService } from "src/app/services/zp-data.service";
import { Router } from "@angular/router";
import { renderFlagCheckIfStmt } from "@angular/compiler/src/render3/view/template";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";
import { PreviousUrlService } from "../services/previous-url.service";

@Component({
  selector: "app-my-dashboard",
  templateUrl: "./my-dashboard.component.html",
  styleUrls: ["./my-dashboard.component.scss"],
})
export class MyDashboardComponent implements OnInit, OnDestroy {
  public myUser: IUser;
  public subscription: Subscription;
  public subscription2: Promise<void>;
  public isDelegate = false;
  public myCategoriesBalance: {}[];
  public mySections: {}[];
  public categorySections;
  public assetsSections: {}[];
  public debtsSections: {}[];
  public dailyLifeSections: {}[];
  public digitalLifeSections: {}[];
  public wishesSections: {}[];
  public testList: [];
  public chosenTab: string;
  public showAssets = false;
  public showDebts = false;
  public showDailyLife = false;
  public showWishes = false;
  public assetsAccess = true;
  public debtsAccess = true;
  public dailyLifeAccess = true;
  public digitalLifeAccess = true;
  public wishesAccess = true;
  public testTab: any;
  public collapseStatus = [];
  public dataIsLoaded: boolean = false;
  public associatedPage: string;
  public accessRightSection: boolean;
  public testArray = { id: "test", color: "#000" };
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public user: any;
  public planUser: any;
  public previousLink: string;
  public hideBanner: string;
  public dismissedBanner: any;
  public hasDelegate: boolean;

  constructor(
    private userInfo: UserInfoService,
    private zenplanData: ZpDataService,
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    private previousUrl: PreviousUrlService
  ) {
    
  }

  async ngOnInit() {
    let dismissedBanner: any = localStorage.getItem("session");
    this.dismissedBanner = dismissedBanner ? JSON.parse(dismissedBanner) : false;
    console.log(this.dismissedBanner);
    this.previousLink = this.previousUrl.getPreviousUrl();
    if (this.previousLink === "/log-in") {
      window.location.reload();
    }
    this.subscription = this.userInfo.getMessage().subscribe((user) => {
      if (user && user !== "null") {
        this.myUser = JSON.parse(user);

        this.dataIsLoaded = false;
        this.fillDashBoard();
        this.dataIsLoaded = true;
      }
    });
    console.log("dashboard, ngOnInit() > Subscription, myUser - ", this.myUser);
    
    this.subscription2 = this.zenplanData.getUser().then(async (user) => {
      this.user = user;
      
      if (this.user.firstName != '' && (!this.user.jointOwners || this.user.jointOwners.length === 0)) {
        let defaultOwner = {
          first: this.user.firstName,
          last: this.user.lastName,
          relationship: "Plan holder",
          default: true,
        };
        this.user.jointOwners = [defaultOwner];
        let userToSave = {
          Id: this.user.Id,
          lastUpdate: new Date(),
          lastUpdateBy: this.user.Id,
          jointOwners: this.user.jointOwners,
        };
        await this.zenplanData.updateUser(userToSave);
        console.log("dashboard, ngOnInit() > Promise Subscription, user - ", this.user);
      }
      this.planUser = await this.zenplanData.getPlan(user["Id"]);
      console.log('planUser - ', this.planUser)
      this.zenplanData.updatePlanIfNotCurrent(user, this.planUser)

      console.log('user - ', this.user)

      if (this.user && this.user.planVersion === 2.2) {
        this.hideBanner = 'true';
      } else {
        this.hideBanner = 'false';
      }
    });
    
    
    //this.fillDashBoard();
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.showTab("assets", null);

    
  }

  dismissBanner() {
    this.hideBanner = 'true';
    localStorage.setItem("session", JSON.stringify(this.hideBanner));
    console.log('myUser - ', this.myUser)
    this.checkIfUserHasDelegate();
  }
  
  async checkIfUserHasDelegate() {
    let delegatesCount = await this.zenplanData.getDelegatesCount(this.myUser.Id);
    if (delegatesCount > 0) {
      this.hasDelegate = true;
      console.log('hasDelegate - ', this.hasDelegate)
      console.log('delegatesCount - ', delegatesCount)
    } else {
      this.hasDelegate = false;
      console.log('hasDelegate - ', this.hasDelegate)
      console.log('delegatesCount - ', delegatesCount)
    }
  }

  async fillDashBoard() {
    if (this.myUser && this.myUser.sharedPlanUserId) {
      //TODO - we are not showing the dashboard to the delegate
      //If we decide to show the dash board to the delegate I assume if and only if
      //all the below access flags are true.
      this.assetsAccess = false;
      this.debtsAccess = false;
      this.dailyLifeAccess = false;
      this.digitalLifeAccess = false;
      this.wishesAccess = false;
      if (
        ["now", "contributor"].includes(
          this.myUser.delegate["assetsPermission"]
        )
      ) {
        this.assetsAccess = true;
      }
      if (
        ["now", "contributor"].includes(
          this.myUser.delegate["debtssPermission"]
        )
      ) {
        this.debtsAccess = true;
      }
      if (
        ["now", "contributor"].includes(
          this.myUser.delegate["dailyLifePermission"]
        )
      ) {
        this.dailyLifeAccess = true;
      }
      if (["now", "contributor"].includes(this.myUser.delegate["digitalLifePermission"])) {
        this.digitalLifeAccess = true;
      }
      if (["now", "contributor"].includes(this.myUser.delegate["wishesPermission"])) {
        this.wishesAccess = true;
      }
    }
    this.myCategoriesBalance =
      await this.zenplanData.getAllPlanCategoriesDashboardInfo(this.myUser);
      console.log('myCategoriesBalance - ', this.myCategoriesBalance)
    //this.mySections = await this.zenplanData.getSectionItemCount
    //prepare the data for the template
    this.myCategoriesBalance.forEach((category) => {
      // category["amount"] = category["assets"]
      //   - category["debts"]
      //   + category["income"]
      //   - category["expense"];
      switch (category["categoryName"]) {
        case "my assets":
          if (this.assetsAccess || !this.myUser.delegate) {
            category["tabName"] = "assets";
            category["navTitle"] = "Assets";
            category["itemCount"] = category["itemCount"];
            category["id"] = "myAssets";
            category["class"] = "section-box";
          }
          break;
        case "my debts":
          if (this.debtsAccess || !this.myUser.delegate) {
            category["tabName"] = "debts";
            category["navTitle"] = "Debts";
            category["itemCount"] = category["itemCount"];
            category["id"] = "myDebts";
            category["class"] = "section-box";
            //category["amount"] = category["debts"];
          }
          break;
        case "my daily life":
          if (this.dailyLifeAccess || !this.myUser.delegate) {
            category["tabName"] = 'dailyLife';
            category["navTitle"] = 'Daily Life';
            category["itemCount"] = category["itemCount"];
            category["id"] = "myDailyLife";
            category["class"] = "section-box";
            //category["amount"] = category["expense"];
          }
          break;
        case "my digital life":
          if (this.digitalLifeAccess || !this.myUser.delegate) {
            category["tabName"] = 'digitalLife';
            category["navTitle"] = 'Digital Life';
            category["itemCount"] = category["itemCount"];
            category["id"] = "myDigitalLife";
            category["class"] = "section-box";
            //category["amount"] = category["expense"];
          }
          break;
        case "my wishes":
          if (this.wishesAccess || !this.myUser.delegate) {
            category["tabName"] = "wishes";
            category["navTitle"] = "Wishes";
            category["itemCount"] = category["itemCount"];
            category["id"] = "myWishes";
            category["class"] = "section-box";
          }
          break;
        case "financial summaries":
          if (this.wishesAccess || !this.myUser.delegate) {
            category["tabName"] = "financialsummaries";
            category["navTitle"] = "Financial Summaries";
            // category["itemCount"] = category["itemCount"];
            category["id"] = "financialSummaries";
            category["class"] = "section-box";
            category["link"] = "financial-summaries";
          }
          break;
      }
    });
    this.assetsSections = this.myCategoriesBalance.find(
      (category) => category["categoryName"] == "my assets"
    )["sections"];

    this.debtsSections = this.myCategoriesBalance.find(
      (category) => category["categoryName"] == "my debts"
    )["sections"];

    this.dailyLifeSections = this.myCategoriesBalance.find(
      (category) => category["categoryName"] == "my daily life"
    )["sections"];

    this.digitalLifeSections = this.myCategoriesBalance.find(category =>
      category["categoryName"] == "my digital life"
    )["sections"];

    this.wishesSections = this.myCategoriesBalance.find(category =>
      category["categoryName"] == "my wishes"
    )["sections"];

    //default:
    if (this.assetsAccess || !this.myUser.delegate) {
      this.categorySections = this.assetsSections;
    }
  }

  // getColor() {
  //   let color = this.testArray.color
  //   return color
  // }

  showTab(pageName: string, evt) {
    this.chosenTab = pageName;
    switch (pageName) {
      case "assets":
        console.log('assets section.')
        if (this.assetsAccess || !this.myUser.delegate) {
          this.categorySections = this.assetsSections;
          this.associatedPage = "dynamicform/my-assets";
        }
        break;
      case "debts":
        console.log('debts section.')
        if (this.debtsAccess || !this.myUser.delegate) {
          this.categorySections = this.debtsSections;
          this.associatedPage = "dynamicform/my-debts";
        }
        break;
      case "dailyLife":
        console.log('daily life section.')
        if (this.dailyLifeAccess || !this.myUser.delegate) {
          this.categorySections = this.dailyLifeSections;
          this.associatedPage = "dynamicform/my-daily-life";
        }
        break;
      case "digitalLife":
        console.log('digital life section.')
        if (this.digitalLifeAccess || !this.myUser.delegate) {
          this.categorySections = this.digitalLifeSections;
          this.associatedPage = 'dynamicform/my-digital-life';
        }
        break;
      case "wishes":
        if (this.wishesAccess || !this.myUser.delegate) {
          this.categorySections = this.wishesSections;
          this.associatedPage = "dynamicform/my-wishes";
        }
        break;
      case "financialsummaries":
        this.router.navigate(["/financial-summaries"]);
    }
  }

  goto(section) {
    // url = url.replace(/ /g, '-');
    this.accessRightSection = section;
    this.myUser.accessRightSection = this.accessRightSection;
    this.getInfoAndPassService.getInfoAndPass(this.accessRightSection);
    this.router.navigate([this.associatedPage]);
  }

  add(url: string) {
    let addUrl = url;
    addUrl = addUrl.replace(/\-edit$/, "") + "_1";
    this.router.navigate(["/" + addUrl]);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
